export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Bold.6a1f56a6.woff2";